export enum WindyLayers {
  WIND = 'wind',
  TEMPERATURE = 'temp',
  RAIN = 'rain',
  PRESSURE = 'pressure',
  WAVES = 'waves',
  CLOUDS = 'clouds',
}

export enum MapboxLayers {
  MAP = 'map',
  DEPTH = 'depth',
  DAY_NIGHT = 'day_night',
}
